type IdPathHelper = (id: string) => string
export const eventCheckInPath: IdPathHelper = id => `/at/${id}`
export const actionNetworkCheckInPath: IdPathHelper = id => `/an/${id}`
